import {anyPass, constant, defaultTo, equals, firstOf, flow, get, groupBy, ifThen} from '@yandex-delivery/utils'

import {type SectionProps as Props, type SlotWidgetConfig, type WidgetConfig, WidgetType} from '../types'

type OptionWidgets = {
  headers: SlotWidgetConfig[]
  children: SlotWidgetConfig[]
  hidden: SlotWidgetConfig[]
}
type OptionType = keyof OptionWidgets

const isHeaderWidget: (widget: SlotWidgetConfig) => boolean = flow(
  get('accessibility_info.is_header'), //
  equals(true),
)
const isHiddenWidget: (widget: SlotWidgetConfig) => boolean = flow(
  get('widget_id'),
  anyPass([
    equals('cargo_c2c_order_forms_b2b_lk_cargo_return_point_information_slot_widget'),
    equals('cargo_c2c_order_forms_b2b_lk_cargo_skip_confirmation_toggle_widget'),
  ]),
)
const byOptionType: (widget: WidgetConfig) => OptionType = flow(
  firstOf(
    ifThen(isHeaderWidget, constant<OptionType>('headers')), //
    ifThen(isHiddenWidget, constant<OptionType>('hidden')),
  ),
  defaultTo<OptionType>('children'),
)

export const groupByOptionType: (props: Props) => OptionWidgets = flow(
  get('section.widgets'), //
  groupBy(byOptionType) as unknown as (w: WidgetConfig[]) => OptionWidgets,
)
export const toHeader = (header: SlotWidgetConfig): SlotWidgetConfig => {
  Object.assign(header.slot, {
    lead: {
      icon_spot: {
        icon: {
          image_tag: 'delivery_order_header_options',
          tint_color: 'text',
        },
        background_color: 'controlMinor',
      },
      type: WidgetType.ICON_SPOT,
    },
  })

  return header
}
